export const constantStrings = {
  errorMessages: {
    multipleReductionScarOnSameBreast: 'Cannot have more than one reduction scar on the same breast',
    multipleMastectomiesOnSameBreast: 'Cannot have more than one mastectomy on the same breast',
    cannotDrawMoreReductionScars: 'You cannot draw more Reduction Scars',
    cannotDrawMoreMastectomies: 'You cannot draw more mastectomies',
    offlineModeFailed: '',
    reconnectingFailed: 'Reconnecting Failed. Before you continue to work, please fix your WiFi network issue. Offline mode is now enabled.'
  },
  aAgeConfigId: 'A_AGE',
  allOption: 'All',
  DefaultSortOption : 'DEFAULT_SORT',
  StudyDateSortOptionAsc: 'STUDY_DATE_ASC',
  StudyDateSortOptionDesc: 'STUDY_DATE_DESC',
  AppoinmentSortOptionAsc: 'APPOINTMENTS_ASC',
  AppoinmentSortOptionDesc: 'APPOINTMENTS_DESC',
  UltrasoundScanTechniqueMultipleScans: 'Multiple Scans',
  UltrasoundScanTechninqueNoScans: '',
  worklistStatuses: {
      New : {
        status: 'New',
        statusAlias : 'Survey Assigned'
      },
      SurveyStarted: {
        status: 'SurveyStarted',
        statusAlias : 'Survey Started'
      },
      SurveyFinished:{
        status: 'SurveyFinished',
        statusAlias : 'Survey Completed'
      },
      ExamWaiting: {
        status: 'ExamWaiting',
        statusAlias : 'Waiting for exam'
      },
      ExamIncomplete: {
        status: 'ExamIncomplete',
        statusAlias : 'Exam Incomplete'
      },
      ExamInProgress: {
        status: 'ExamInProgress',
        statusAlias : 'Exam Started'
      },
      ExamPaused:{
        status:  'ExamPaused',
        statusAlias : 'Exam Paused'
      },
      ExamStopped: {
        status: 'ExamStopped',
        statusAlias : 'Exam Ended'
      },
      Finished: {
        status: 'Finished',
        statusAlias : 'Exam Finished'
      },
      UltrasoundRequested:{
        status:  'UltrasoundRequested',
        statusAlias : 'Ultrasound Requested'
      },
      RISWaiting: {
        status: 'RISWaiting',
        statusAlias : 'Waiting for RIS'
      },
      TakeExam: {
        status: 'TakeExam',
        statusAlias : 'Take Exam'
      },
      ReviewComplete:{
        status:  'ReviewComplete',
        statusAlias : 'Review Complete'
      }
  },
  worklistAddditionalInfo: {
    ReleasePatient: {
      infoCode: 'ReleasePatient',
      infoAlias: 'Release Patient'
    },
    AdditionalImaging:{
      infoCode: 'AdditionalImaging',
      infoAlias: 'Additional Imaging'
    } ,
    UltrasoundRequested:{
      infoCode: 'UltrasoundRequested',
      infoAlias: 'Ultrasound Requested'
    } ,
    Other: {
      infoCode: 'Other',
      infoAlias: 'Other'
    }
  },
  common: {
    Yes: 'Y',
    No: 'N',
  },
  newUltrasoundTechniqueDescripton: 'New Technique',
  Lfrom: 'Lfrom',
  Lto: 'Lto',
  LIST: 'LIST',
  Axilla: 'Axilla',
  DateMinValue: -8640000000000000,
  DateMaxValue: 8640000000000000,
  DateTimeNullValue: '0001-01-01T00:00:00+00:00',
  DefaultLoaderMessage: 'Loading...',
  MaxRefPhiesPerPatient: 10,
  DefaultTimeoutRetryOnOffline: 10000,
  DefaultStudyDateFormat: 'MM/dd/yyyy',
  DefaultStudyDateUrlFormat: 'MM-dd-yyyy',
  DATE_OBJECT_TYPE: 'date',
  FunctionObjectType: 'function',
  DefaultRevertChangesConfirmationMessage: 'You have unsaved changes, are you sure you want to revert them?',
  DefaultOfflineAlertMessage: `You are currently offline, please check your network settings and try again`,
  DefaultEmailInUseAlertMessage: 'Email already exists',
  GeneratingPinLoadingMessage: 'Generating Pin...',
  ReadyForExam: 'ReadyForExam',
  YouHaveNotReviewedExamTabDefaultMessage: 'Please review the Exam tab to ensure all required fields have been completed before ending the exam.',
  YouHaveNotReviewedProblemsOnExamTabMessage: 'You have not specified the problems on Exam tab. Please specify the problems before ending exam.',
  YouHaveNotReviewedDemographicTabDefaultMessage: 'Please review the Demographic tab to ensure all required fields have been completed before ending the exam.',
  AgeOfFirstPregnancyCanNotBeGreaterThanAgeAtMenarche: 'The age of menarche cannot be greater than the age of first pregnancy.',
  YouHaveNotReviewedHistoryTabDefaultMessage: 'Please review the History tab to ensure all required fields have been completed before ending the exam.',
  PleaseWait: 'Please wait...',
  DiagramFullScreenEventName: 'diagram:fullscreen',
  DiagramCarryForwardImageMissing: 'SDiagram carry forward image is missing.',
  DefaultDiagramLoadError : 'Error happened while loading diagram',
  ObjectName : 'object',
  CommentsRefreshConfirmation: 'Comments Refresh Confirmation',
  NoDiscardCommentsMessage: 'No, discard my comments',
  YesDiscardCommentsMessage: 'Yes, keep my updated comments',
  AssertiveButton: 'button-assertive'
};
export const defaultDateTimeSqlMinValue = '1900-01-01T00:00:00';
export const defaultDateTimeMinValue = '0001-01-01T00:00:00';
export const OFFLINE_ERROR_MESSAGE = 'You are currently offline, please check your network settings and try again';
export const processingLoaderMessage = 'Processing...';
export const maleGenderCode = 'M';
export const femaleGenderCode = 'F';
export const defaultFullDateFormat = 'MM/dd/yyyy hh:mm:ss a';
export const DEFAULT_FOX_PRO_EMPTY_DATE = '/  /';
export const DEFAULT_TECHPAD_CONTROL_DATE_EMPTY_DATE = '//';
export const advancedConfirmationSaveResponse = 'save';
export const advancedConfirmationDiscardResponse = 'discard';
export const advancedConfirmationCancelResponse = 'cancel';
export const advancedConfirmationSaveButtonText = 'Save & Exit';
export const advancedConfirmationDiscardButtonText = 'Discard Changes';
export const advancedConfirmationCancelButtonText = 'Cancel';
export const advancedConfirmationSkipButtonText = 'Skip';
export const modalButtonDefaultClass = 'button-positive ripple';
export const MODAL_BUTTON_ASSERTIVE_CLASS = 'button-assertive';
export const savingHistoryLoaderMessage = 'Saving History...';
export const commentsChangedInDbMessage = '<strong>Comments were recently changed. Do you want to overwrite with your comments?</strong>';
export const commentsChangedPopupMessage = 'Comments Changed Confirmation';
export const commentsChangedDiscardButtonText = 'No, discard my comments';
export const commentsChangedConfirmButtonText = 'Yes, overwrite recently updated comments';
export const IMPLANTS_OMIT_ITEMS_ARRAY = ['clearOthers', 'typeSpecified', 'combined'];
export const STUDY_LOCAKED_EXCEPTION_CLASS_NAME = 'MVPatientsPortal.Core.Dtos.StudyMayHaveBeenLockedException';
export const STUDY_MODIFIED_EXCEPTION_CLASS_NAME = 'MVPatientsPortal.Core.Dtos.StudyMayHaveBeenModifiedException';
export const STUDY_MODIFIED_EXCEPTION_MESSAGE = 'Study has been opened by others';
export const ALERT_CLOSE_BUTTON_TEXT = 'Close';
export const PROBLEMS_DATA = 'Problems';
export const VIEWS_OBTAINED_DATA = 'Views Obtained';
export const PROCEDURE_SIDE_DATA = 'Procedure Side';
export const REASON_FOR_VISIT_DATA = 'Reason for Visit';
export const INFECTION_CONTROL_DATA = 'Infection Control';
export const PERSONAL_BRCA_FIELD_ID = 'personal_brca';
export const PERSONAL_BRCA1_ANSWER_KEY = 'PERSONAL_BRCA1';
export const PERSONAL_BRCA2_ANSWER_KEY = 'PERSONAL_BRCA2';
export const MAX_DATE_YEARS_TO_THE_FUTURE = 100;
export const DECEMBER_MONTH_NUMBER = 12;
export const DECEMBER_LAST_DAY = 31;
export const DEFAULT_POPUP_HEADER = 'Techpad';
export const DEFAULT_POPUP_CONFIRM_BUTTON_TEST = 'Yes';
export const DEFAULT_POPUP_DECLINE_BUTTON_TEST = 'No';
export const DEFAULT_POPUP_CONFIRM_BUTTON_CLASS = 'button-positive';
export const DEFAULT_POPUP_DECLINE_BUTTON_CLASS = 'button-default';
export const FINISHED_WORKLIST_STATUS = 'Finished';
export const DASHBOARD_PAGE_ROUTE = '/root/worklist';
export const MY_PATIENTS_PAGE_ROUTE = '/root/worklist/mypatients';
export const DEFAULT_NOT_COMPLETED_SURVEY_ERROR_ON_LEAVE_PAGE = 'You didn\'t complete the survey. Are you sure you want to leave this exam?';
export const VIEW_ONLY_URL_PARAMETER = 'viewOnly';
export const CLEAR_DIAGRAM_PROBLEM_EVENT = 'diagram:clearProblemSelection';
export const LOCK_DIAGRAM_DRAGGING_EVENT = 'diagram:lockDragging';
export const UNLOCK_DIAGRAM_DRAGGING_EVENT = 'diagram:unlockDragging';
export const DEFAULT_NOT_SAVED_DATA_ERROR_ON_LEAVE_PAGE = 'You have not saved data here. Are you sure you want to leave this exam?';
export const DEFAULT_EXAM_REQUIRES_RIS_MESSAGE = 'This item requires RIS record. Did you create this record?';
export const US_REQUESTED_WORKLIST_STATUS = 'UltrasoundRequested';
export const DEFAULT_UPDATE_WORKLIST_STATUS_ERROR_MESSAGE = 'Error updating worklist status';
export const DEFAULT_LOADER_MESSAGE = 'Loading...';
export const RIS_WAITING_WORKLIST_STATUS = 'RISWaiting';
export const PATIENT_ARRIVED_IMHERE_WORKLIST_STATUS = 'PatientArrived';
export const EXAM_LOCKED_POPUP_HEADER = 'Exam Locked';
export const STUDY_LOCKED_POPUP_CONFIRM_BUTTON = 'Unlock this study';
export const CLEAR_CACHE_WARNING_MESSAGE = 'Clicking this button will clear the cache and refresh the application on this device. This will require you to re-enter the Hospital Code and log in with your credentials again. Do you wish to proceed?';
export const CLEAR_CACHE_CONFIRMATION_MESSAGE = 'To confirm, do you wish to proceed with clearing the cache and refreshing the application on this device?';
export const CLEAR_CACHE_CONFIRMATION_TITLE = 'Confirm Hard Refresh';
export const UNLOCK_STUDY_CONFIRMATION_MESSAGE = 'Are you sure to remove lock from this study and assign it to you ?';
export const UNLOCKED_EXAM_POPUP_HEADER = 'Unlock Exam Confirmation';
export const UNLOCKED_EXAM_POPUP_CONFIRM_BUTTON = 'Yes, Unlock It';
export const DEFAULT_UNLOCK_STUDY_ERROR_MESSAGE = 'Error unlocking study';
export const DEFAULT_STUDY_NOT_FOUND_IN_DB_ERROR_MESSAGE = 'This study record not found in database';
export const DEFAULT_WORKLIST_ON_HOLD_ERROR_MESSAGE = 'This worklist item is currently on hold.';
export const DEFAULT_ASSIGN_STUDY_TO_YOU_ERROR_MESSAGE = 'Error assigning study to you';
export const DEFAULT_CHECK_IF_ASSIGNED_TO_ME_ERROR_MESSAGE = 'Error checking if assigned to you';
export const UNKNOWN_TECH_STRING = '<unknown technologist>';
export const UNKNOWN_WORKSTATION_STRING = '<unknown workstation>';
export const STUDY_REPORT_UNAVAILABLE = 'The report for the selected study is not available.';
export const REPORT_UNAVAILABLE = 'Report Not Available';

export const ON_FAMILY_TREE_SAVED_CHANGES_FOUND_CONFIRMATION_MESSAGE = 'You have not saved data which maybe lost. Do you want to save your changes before reloading data?';
export const ON_FAMILY_TREE_SAVED_CONFIRMATION_BUTTON_TEXT = 'Reload';
export const ON_RISK_UPDATE_CHANGES_FOUND_CONFIRMATION_MESSAGE = 'You have not saved data which maybe lost. Do you want to save your changes before updating risk score?';
export const ON_RISK_UPDATE_CONFIRMATION_BUTTON_TEXT = 'Update';
export const DEFAULT_CALC_RISK_ERROR_MESSAGE = 'Error updating risk score';
export const DEFAULT_CALC_RISK_LOADING_MESSAGE = 'Recalculating Risks...';
export const DEFAULT_SAVE_CONTACT_LOADING_MESSAGE = 'Saving Contact';
export const DEFAULT_SAVE_CONTACT_ERROR_MESSAGE = 'Error saving contact';
export const DEFAULT_LOAD_PATIENT_DATA_ERROR_MESSAGE = 'Error loading patient data';
export const DEFAULT_LOAD_CONTACT_TYPES_ERROR_MESSAGE = 'Error loading contact types';
export const DEFAULT_LOAD_FU_ERROR_MESSAGE = 'Error loading follow-ups';
export const DEFAULT_LOAD_FU_RECOMMENDATIONS_ERROR_MESSAGE = 'Error loading follow-up recommendations';
export const DEFAULT_CONTACT_TYPE_REQUIRED_MESSAGE = 'You must specify contact type to save a contact record';
export const CONTACT_DOCUMENT_SOURCE = 'Contacts';
export const PORTAL_DOCUMENT_SOURCE = 'PortalDocument';
export const DOCUMENT_LOADING_MESSAGE = 'Loading document...';
export const DEFAULT_CHANGES_DETECTED_ON_POPUP_CLOSE_CONFIRMATION_MESSAGE = 'Are you sure you want to close this window without saving changes?';
export const DEFAULT_DELETE_CONTACT_CONFIRMATION_MESSAGE = 'Are you sure you want to delete this contact?';
export const DEFAULT_DELETE_PORTAL_DOCUMENT_CONFIRMATION_MESSAGE = 'Are you sure you want to delete this document?';
export const DEFAULT_REMOVE_CONTACT_ERROR_MESSAGE = 'Error deleting contact';
export const DEFAULT_REMOVE_DOCUMENT_ERROR_MESSAGE = 'Error deleting document';
export const DEFAULT_DELETE_CONTACT_LOADING_MESSAGE = 'Deleting Contact...';
export const DEFAULT_DELETE_PORTAL_DOCUMENT_LOADING_MESSAGE = 'Deleting Document...';
export const DEFAULT_DELETE_FU_CONFIRMATION_MESSAGE = 'Are you sure you want to delete this follow-up?';
export const DEFAULT_DELETE_FU_LOADING_MESSAGE = 'Deleting Follow-Up...';
export const DEFAULT_REMOVE_FU_ERROR_MESSAGE = 'Error deleting follow-up';
export const DEFAULT_LOAD_FU_RESOLUTIONS_ERROR_MESSAGE = 'Error loading follow-up resolutions';
export const DEFAULT_RESOLVE_FU_LOADING_MESSAGE = 'Resolving Follow-Up...';
export const DEFAULT_RESOLVE_FU_ERROR_MESSAGE = 'Error resolving follow-up';
export const DEFAULT_FU_RESOLUTION_REQUIRED_MESSAGE = 'You must indicate a reason for closing follow-up';
export const DEFAULT_CONTACT_SAVED_MESSAGE = 'Contact saved successfully.';
export const DEFAULT_LOAD_FU_FINDINGS_ERROR_MESSAGE = 'Error loading follow-up findings';
export const DEFAULT_LOAD_FU_FINDINGS_LOADING_MESSAGE = 'Loading Follow-Up Findings...';
export const DEFAULT_CHECK_WORKLIST_EXIST_ERROR = 'Error checking if worklist exists';
export const DEFAULT_CREATE_WORKLIST_ERROR = 'Error creating worklist';
export const PATIENT_GENETIC_TESTING = 'This patient qualifies for additional genetic testing. Would you like to refer them to Myriad?';
export const REFER_TO_MYRIAD = 'Refer to Myriad';
export const PATIENT_REFUSES = 'Patient Refuses';
export const PATIENT_AGREED_ID ='PatientAgreed';
export const PATIENT_NOT_INTERESTED_ID = 'PatientNotInterested';

export const DEFAULT_FU_LETTERS_NONE_CODE = 0;
export const DEFAULT_FU_LETTERS_NONE_DESCRIPTION = 'None';
export const DEFAULT_FU_LETTERS_FIRST_CODE = 1;
export const DEFAULT_FU_LETTERS_FIRST_DESCRIPTION = 'First';
export const DEFAULT_FU_LETTERS_SECOND_CODE = 2;
export const DEFAULT_FU_LETTERS_SECOND_DESCRIPTION = 'Second';
export const DEFAULT_FU_LETTERS_THIRD_CODE = 3;
export const DEFAULT_FU_LETTERS_THIRD_DESCRIPTION = 'Third';
export const BODY_TAG = 'body';
export const POPOVER_CLASS = 'popover-open';
export const MODAL_BACKGROUND_CLASS = 'div.modal-backdrop';
export const MODAL_CLASS = 'modal';
export const MODAL_OPEN_CLASS = 'modal-open';
export const MODAL_ACTIVE_CLASS = 'active';
export const DISTANCE_FROM_NAME = 'Dfrom'
export const DISTANCE_TO_NAME = 'Dto'
export const CM_NAME = 'cm'
export const POPUP_CONTAINER_CLASS = 'popup-container';
export const POPUP_CONTAINER_ACTIVE_CLASS = 'active';
export const POPUP_CONTAINER_VISIBLE_CLASS = 'visible';
export const POPUP_CONTAINER_HIDDEN_CLASS = 'popup-hidden';
export const POPUP_BACKGROUND_CLASS = 'backdrop';
export const POPUP_OPENED_BODY_CLASS = 'popup-open';

export const MENARCHE_AGE_FIELD_ID = 'A_AGE';
export const FIRST_PREGNANT_FIELD_ID = 'P_AGE';

export const WORKLIST_MESSAGE_ID = 3;
// Version Check Service Constants
export const VERSION_CHECK_API_PATH = '/Custom/public/versions.json';
export const VERSION_INVALID_FORMAT_ERROR = 'Invalid version data format received';
export const VERSION_RELOAD_ERROR = 'Failed to reload application';
export const FAILED_TO_CLEAR_CACHE = 'Failed to clear cache';

// Procedure Side Keys
export const SIDE_UNKNOWN_KEY = 'U';
export const SIDE_LEFT_KEY = 'L';
export const SIDE_RIGHT_KEY = 'R';
export const SIDE_BILATERAL_KEY = 'B';

// Procedure Side Mapping
export const PROCEDURE_SIDE_MAPPING = [
  { code: 'B', name: 'Bilat' },
  { code: 'R', name: 'Right' },
  { code: 'L', name: 'Left' },
  { code: 'U', name: 'Unknown' },
  { code: '', name: 'Unknown' },
  { code: null, name: 'Unknown' },
  { code: undefined, name: 'Unknown' }
]; 


// WEBPACK FOOTER //
// ./src/scripts/constants/constantStrings.js